module.exports = __webpack_public_path__ + "static/media/next.ba9d5e31.m4a";